import React from 'react';
import { formatDate, cleanProviderName } from '../../utils';

const StatusPurchase = (props) => (
  <React.Fragment>
    <div className="title-box">Dados do pedido</div>
    <div className="box-post-purchase">
      <div className="infos-plan-purchase-header">
        <img src={`/assets/images/seguradoras/${cleanProviderName(props.purchase.provider)}.png`} alt="Seguradora" className='logo-seguradora' />
        <p>
          <b>Plano:</b>&nbsp;
          {props.purchase.product}
        </p>
      </div>
      <div className="infos-body">
        <p>
          <b>Seguradora:</b>&nbsp;
          {props.purchase.provider}
        </p>
        <p>
          <b>Destino:</b>&nbsp;
          {props.purchase.destination}
        </p>
        <p>
          <b>Período:</b>&nbsp;
          {formatDate(props.purchase.departure_date)} a {formatDate(props.purchase.return_date)}
        </p>
      </div>
    </div>
  </React.Fragment>
);

export default StatusPurchase;



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusPurchase.jsx